<template>
  <v-app
    v-if="ready"
    :class="{ 'v-application--is-mobile': isMobile }">
    <component
      :is="layout.components"
      v-if="!!layout.label"
      :class="`base-layout layout-${layout.label}`"
      :window-width="$vuetify.breakpoint.width"
      :window-height="$vuetify.breakpoint.height"
      :is-mobile="isMobile" />
    <snackbar
      :value="snackbar.value"
      :message="snackbar.message"
      :type="snackbar.type"
      :can-close="snackbar.canClose"
      :timeout="snackbar.timeout"
      @close="closeSnackbar" />
    <modal
      :active="modal.value"
      :confirm-text="modal.confirmText"
      :cancel-text="modal.cancelText"
      :message="modal.message"
      :title="modal.title"
      :confirm-only="modal.confirmOnly"
      :confirm-type="modal.confirmType"
      @onConfirm="confirmModal"
      @onCancel="closeModal" />
    <modal-confirm
      :active="!isUpToDate"
      :confirm-text="'Reload'"
      :title="'New Version Found.'"
      :message="'Please click reload to update new version.'"
      :show-cancel="false"
      @onConfirm="$router.replace({ name: 'Logout' })" />
    <page-loading />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import snackbar from '@/components/Snackbar'
import modal from '@/components/Modal'
import pageLoading from '@/components/PageLoading'
import modalConfirm from '@/components/ModalConfirm'
import axios from 'axios'

export default {
  components: {
    snackbar,
    modal,
    pageLoading,
    modalConfirm
  },
  data () {
    return {
      ready: false,
      isUpToDate: true
    }
  },
  computed: {
    ...mapGetters({
      snackbar: 'Style/snackbar',
      modal: 'Style/modal',
      darkMode: 'Style/darkMode'
    }),
    layout () {
      let layout = 'Default'
      if (this.$route.layout) {
        layout = this.$route.layout
      }
      return {
        label: layout,
        components: () => import(`./components/layout/${layout}.vue`)
      }
    },
    isMobile () {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
    }
  },
  watch: {
    darkMode (val) {
      this.$vuetify.theme.dark = val
    }
  },
  created () {
    this.checkVersion()
    setInterval(this.checkVersion, 10000)
  },
  mounted () {
    this.$vuetify.theme.dark = this.darkMode
    this.ready = true
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar',
      setModal: 'Style/setModal',
      setDarkMode: 'Style/setDarkMode',
      setLoading: 'Style/setLoading'
    }),
    checkVersion () {
      const vm = this
      const now = Date.now()
      axios.get(`/version.txt?t=${now}`)
        .then((response) => {
          const clientScriptVersion = window.campVersion.trim()
          const serverScriptVersion = response.data.trim()
          if (clientScriptVersion === serverScriptVersion) {
            vm.isUpToDate = true
          } else {
            vm.isUpToDate = false
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
    },
    confirmModal () {
      if (this.modal.onConfirm) {
        this.modal.onConfirm()
      }
      this.setModal({
        value: false
      })
    },
    closeModal () {
      if (this.modal.closeModal) {
        this.modal.closeModal()
      }
      this.setModal({
        value: false
      })
    },
    closeSnackbar () {
      this.setSnackbar({
        value: false
      })
    }
  }
}

</script>

<style lang='scss'>
$body-font-family: 'Roboto', 'TH Sarabun', sans-serif !important;
html {
  overflow-y: auto;
}
#app {
  font-family: $body-font-family;
  .display-4 {
    font-family: $body-font-family;
  }
  .display-3 {
    font-family: $body-font-family;
  }
  .display-2 {
    font-family: $body-font-family;
  }
  .display-1 {
    font-family: $body-font-family;
  }
  .headline {
    font-family: $body-font-family;
  }
  .title {
    font-family: $body-font-family;
  }
  .subtitle-1 {
    font-family: $body-font-family;
  }
  .subtitle-2 {
    font-family: $body-font-family;
  }
  .body-1 {
    font-family: $body-font-family;
  }
  .body-2 {
    font-family: $body-font-family;
  }
  .caption {
    font-family: $body-font-family;
  }
  .overline {
    font-family: $body-font-family;
  }
}
// html::-webkit-scrollbar {
//   display: none;
// }
header.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: #ffffff;
}
.theme--light main.v-main {
  background-color: #f1f1f1;
}
.theme--dark main.v-main {
  background-color: #464646;
}
.v-application--is-mobile .base-layout {
  height: calc(100vh - 110px);
}
.v-application .base-layout {
  max-height: calc(100vh);
  height: calc(100vh);
}
.v-application main.v-main {
  min-height: 100vh;
}
.v-application--is-ltr div.v-list-item__action:first-child,
.v-application--is-ltr div.v-list-item__icon:first-child {
  margin-right: 10px;
}
.v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action > .v-list-group__items > a.v-list-item {
  padding-left: 35px;
}
.main-card.v-card {
  height: 100%;
  margin-top: 3px;
  overflow-y: auto;
}
.form-group.d-flex>.label-input {
  margin: 0;
}
.label-input {
  display: flex;
  align-items: center;
  width: 110px;
  margin-bottom: 5px;
}
.upload input[type=file] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  outline: none;
  cursor: pointer;
  z-index: -1;
}
.upload {
  display: inline-flex;
}
.control {
  width: 100%;
  box-sizing: border-box;
  clear: both;
  font-size: 1rem;
  position: relative;
  text-align: left;
}
.upload .upload-draggable {
  width: 100%;
  cursor: pointer;
  padding: 0.25em;
  border: 1px dashed #b5b5b5;
  border-radius: 6px;
}
.form-group {
  position: relative;
}
.error-input {
  position: absolute;
  font-size: 11px;
  bottom: -18px;
  color: red;
  right: 5px;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cs-pointer {
  cursor: pointer;
}
// header.app-bar-mobile > .v-toolbar__content * {
//   color: #ffffff;
// }
header.app-bar-mobile >.v-toolbar__extension {
  background-color: #ffffff;
}
.skus-table table {
  margin-bottom: 10px;
}
.v-input input {
  font-family: "Arial" !important;
}
#sidebar .v-list-item--link:before {
  background-color: #000000;
  box-shadow: inset -2px -1px 2px 1px #717171;
}
#sidebar .v-list-group__header.v-list-item {
  height: 40px;
}
#sidebar .v-list-item.v-list-item--active:hover::before {
  opacity: 0.24;
}
#sidebar .v-list-group__header.v-list-item:hover::before,
#sidebar .v-list-item:hover::before {
  opacity: 0;
}
</style>
